import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { INotificationType } from '@obvious.tech/constellation'

export const NotificationType = defineEntity('NotificationType', {
  endpoint: 'notifications/api/NotificationType',
  schema: SNoop<INotificationType>(),
})
